let RouterArr = []
const Routers = require.context('./../modules/', true, /\.router\.js$/)
Routers.keys().forEach(key => {
  RouterArr = RouterArr.concat(Routers(key).default)
})
RouterArr.sort((a, b) => {
  return a.meta.weights - b.meta.weights
})
// sessionStorage.setItem('navigate', JSON.stringify(RouterArr))
export default [
  ...RouterArr,
  // {
  //   path: '/401',
  //   name: 'error_401',
  //   component: () => import(/* webpackChunkName: 'error' */ '../view/error/401.vue'),
  // },
  // {
  //     path: '/500',
  //     name: 'error_500',
  //     component: () => import(/* webpackChunkName: 'error' */ '../view/error/500.vue'),
  // },
  // {
  //     path: '*',
  //     name: 'error_404',
  //     component: () => import(/* webpackChunkName: 'error' */ '../view/error/404.vue'),
  // },
]
